import React from 'react';
import ZoomButtons from 'utils/components/Zoom/ZoomButtons';
import SelectionStatus from 'portfolio/components/SelectionStatus';

import { IntraDayProfileDataItem } from '../chart/IntraDayProfileData';
import IntraDayProfileLegendContainer from '../legend/IntraDayProfileLegendContainer';
import IntraDayProfileSettings from '../settings/IntraDayProfileSettings';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { useIntradayProfileDimensions } from 'widgets/intraDayProfile/dimensions';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { useWidgetMessagesAdornedWithSymbologyWarning } from 'widgets/WidgetSymbologyWarning';
import { StreamMessage } from 'utils/messages/StreamMessage';

interface IntraDayProfileHeaderProps {
    widgetHeight: number;
    dataSeries: IntraDayProfileDataItem[];
    bucketSize: number;
    containerLeft: number;
    messages: StreamMessage[];
}

export default function IntraDayProfileHeader(
    props: IntraDayProfileHeaderProps
) {
    const {
        containerLeft,
        dataSeries,
        bucketSize,
        messages: messagesProps,
    } = props;
    const { hideLegends } = useIntradayProfileDimensions();

    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    const widgetMessages = useWidgetMessagesAdornedWithSymbologyWarning();
    const messages = [...messagesProps, ...widgetMessages];

    return (
        <WidgetToolbarShowHidePanel
            mustShow={!hasValidSelection || !hideLegends}
        >
            <div className="IntraDayProfileHeader panel-header">
                {hasValidSelection && !hideLegends ? (
                    <IntraDayProfileLegendContainer
                        dataSeries={dataSeries}
                        containerLeft={containerLeft}
                    />
                ) : (
                    <div className="toolbar">
                        <SelectionStatus
                            selectionRequirements={
                                portfolioSelectionRequirements
                            }
                            widgetName="Intraday Profile Widget"
                        />
                    </div>
                )}
                <WidgetToolbar
                    fixedItems={hasValidSelection ? <ZoomButtons /> : undefined}
                    showEditLayout={hasValidSelection}
                    settingsHeader="Intra Day Profile Settings"
                    settingsBody={
                        <IntraDayProfileSettings bucketSize={bucketSize} />
                    }
                    messages={messages}
                    hideMessages={!hasValidSelection}
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
